export default "__VITE_PUBLIC_ASSET__c16b4bec__"